import ObituaryLink from './obituaryLink';
export default ObituaryLink;
